import {SignUpComponent} from "./SignUpComponent.js";
import {addJoinUseInttId, getEmail} from "../store.js";


export class InviterList extends SignUpComponent {

    template() {
        const {inviterList = []} = this.$props;
        return inviterList.map((inviterInfo) => this.getInviterItemTemplate(inviterInfo)).join(" ")
    }

    getInviterItemTemplate(inviterInfo) {
        const {
            FLNM = '',
            PRFL_PHTG = '',
            USER_ID = '',
            USE_INTT_ID,
            USE_INTT_NM = '',
        } = inviterInfo;
        const companyInfoContents = !Mutil.empty(USE_INTT_NM) ? `<dd>${USE_INTT_NM}</dd>` : ''
        return `
         <li  class="js-inviter-li" use-intt-id="${USE_INTT_ID}">
                  <a>
                    <img src="${PRFL_PHTG}" alt="" onerror="this.src='/flow-renewal/assets/images/profile-default.png'">
                    <div>
                      <dl>
                        <dt>${i18next.t(login.invitationFrom , { val : Mutil.n2v(FLNM, USER_ID) })}</dt>
                        ${companyInfoContents}
                      </dl>
                    </div>
                    <i class="sign-icons-arrow-right"></i>
                  </a>
               </li>`
    }

    setEvent() {
        const {
            moveCompanyInfoPage = Mutil.noop
        } = this.$props;
        this.addEvent("click.stop", ".js-inviter-li", (e) => {
            const $inviterItems = $(e.target).closest(".js-inviter-li");
            const joinUseInttId = $inviterItems.attr("use-intt-id");
            addJoinUseInttId(joinUseInttId);
            moveCompanyInfoPage();
        })
    }
}